import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from '../HomePage/HomePage'; // Old Coinlye homepage
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3'; // PEPE THE OG
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import AboutPage from '../AboutPage/AboutPage';
import ContactPage from '../ContactPage/ContactPage';
import TokenPage from '../TokenPage/TokenPage';
import SigninPage from '../SigninPage/SigninPage';
import SignupPage from '../SignupPage/SignupPage';
import PresalePage from '../../components/Memecoin-Components/PresalePage/PresalePage';

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Default homepage is now PEPE THE OG */}
          <Route path="/" element={<HomePage3 />} />

          {/* Old Coinlye homepage available if needed */}
          <Route path="home_ico" element={<Homepage />} />
          
          <Route path="home_memecoin" element={<HomePage2 />} />
          <Route path="home_pepecoin" element={<HomePage3 />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="about" element={<AboutPage />} />   
          <Route path="token" element={<TokenPage />} />   
          <Route path="memecoin-presale" element={<PresalePage />} />
          <Route path="sign_in" element={<SigninPage />} />
          <Route path="sign_up" element={<SignupPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
